<template>
    <v-app>
        <router-view name="header"></router-view>

        <v-main>
            <v-container fluid>
                <router-view></router-view>
            </v-container>
        </v-main>

        <router-view name="footer"></router-view>
        <error-modal></error-modal>
        <success-modal></success-modal>
        <info-modal></info-modal>
        <help-caption-modal></help-caption-modal>
    </v-app>
</template>
<style>
    html, body {
        background-color: var(--v-background-base);
    }
</style>
<script>
    import ErrorModal from "./components/modal/ErrorModal";
    import InfoModal from "./components/modal/InfoModal";
    import SuccessModal from "./components/modal/SuccessModal";
    import HelpCaptionModal from "./components/help/HelpCaptionModal";
    import * as am4core from "@amcharts/amcharts4/core";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    export default {
        name: "App",
        components: {
            ErrorModal,
            SuccessModal,
            InfoModal,
            HelpCaptionModal
        },
        provide() {
            const globalColourMap = {
                nameToInt(name) {
                    //return a 0-9 int based on the serise name
                    var n = name.split("(")[0].trim();
                    if (this.map.has(n)) {
                        return this.map.get(n) % 10;
                    }
                    var i = 0;

                    //randomly named series needs to get the next avaliable number greater than 8
                    if (Array.from(this.map.values()).length > 0) {
                        var max = Math.max(...this.map.values());
                        i = max + 1;
                    }

                    this.map.set(n, i);
                    return i % 10; //colorsets only have ten colours so we need to reuse
                },
                map: new Map()
            }
            
            return {
                globalColourMap: globalColourMap
            };
        },
        methods: {
            async setup() {
                const isThemeDark = localStorage.getItem("theme-dark");

                if (isThemeDark) {
                    this.$vuetify.theme.dark = isThemeDark === "true";
                }

                am4core.useTheme(am4themes_animated);
                am4core.useTheme(this.am4themes_myTheme);

            },
            am4themes_myTheme(target) {
                if (target instanceof am4core.InterfaceColorSet) {

                    const theme = this.$vuetify.theme.themes[this.$vuetify.theme.dark === true ? "dark" : "light"];
                    const textColor = this.$vuetify.theme.dark === true ? "#fff" : "#000";
                    const background = this.$vuetify.theme.dark === true ? "#000" : "#fff";

                    target.setFor("primaryButton", am4core.color(theme.primary));
                    target.setFor("primaryButtonHover", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonDown", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonActive", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("primaryButtonText", am4core.color(textColor));
                    target.setFor("primaryButtonStroke", am4core.color(theme.primary));

                    target.setFor("secondaryButton", am4core.color(theme.primary));
                    target.setFor("secondaryButtonHover", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonDown", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonActive", am4core.color(theme.primary).lighten(-0.2));
                    target.setFor("secondaryButtonText", am4core.color(textColor));
                    target.setFor("secondaryButtonStroke", am4core.color(theme.primary));

                    target.setFor("alternativeBackground", am4core.color(theme.primary));
                    target.setFor("background", am4core.color(background));

                    target.setFor("text", am4core.color(textColor));
                    target.setFor("fill", am4core.color(theme.primary));
                    target.setFor("grid", am4core.color(textColor));
                }

                if (target instanceof am4core.ColorSet) {
                    target.list = [
                        am4core.color("#aad2ed"),
                        am4core.color("#8e5ea2"),
                        am4core.color("#3cba9f"),
                        am4core.color("#ad010f"),
                        am4core.color("#f79c40"),
                        am4core.color("#365b87"),
                        am4core.color("#bf9bcf"),
                        am4core.color("#8fad89"),
                        am4core.color("#f990a7"),
                        am4core.color("#948701")
                    ];
                }
            }
        },
        computed: {
            theme() {
                return (this.$vuetify.theme.dark) ? 'dark' : 'light'
            }
        },
        mounted() {
            this.setup();
        }

    };
</script>
